import { RenderTexture, Text, useCursor } from '@react-three/drei'
import type { ThreeElements } from '@react-three/fiber'
import { useState } from 'react'

import { RenderTextureScene } from '@components/helpers'
import { WoodenSignSmallModel } from '@components/models'
import { useIsTouch } from '@hooks'

type WoodenSignButtonProps = ThreeElements['group'] & {
  label: string
  disabled?: boolean
  icon?: boolean
  secondary?: boolean
}

export function WoodenSignButton({
  label,
  disabled,
  icon,
  secondary,
  onClick,
  ...props
}: WoodenSignButtonProps) {
  const isTouch = useIsTouch()
  const [hovered, setHovered] = useState(false)
  useCursor(hovered)

  const _disabled = disabled || !onClick

  return (
    <group {...props}>
      <group position-y={secondary ? -0.7 : 0}>
        <WoodenSignSmallModel
          secondary={secondary}
          highlight={!_disabled && (isTouch || hovered)}
          onClick={e => {
            if (_disabled) return
            e.stopPropagation()
            // @ts-expect-error wrong drei typings
            onClick?.()
          }}
          onPointerOver={e => {
            if (_disabled) return
            e.stopPropagation()
            setHovered(true)
          }}
          onPointerOut={e => {
            if (_disabled) return
            e.stopPropagation()
            setHovered(false)
          }}
          onPointerEnter={e => {
            if (_disabled) return
            e.stopPropagation()
            setHovered(true)
          }}
          onPointerLeave={e => {
            if (_disabled) return
            e.stopPropagation()
            setHovered(false)
          }}
        />
        <mesh position={[0.666, 1.45, 0]} renderOrder={5}>
          <planeGeometry />
          <meshBasicMaterial />
          <meshBasicMaterial transparent depthTest={false}>
            <RenderTexture attach="map" width={512} height={512}>
              <RenderTextureScene>
                <Text
                  font="/fonts/jaro.ttf"
                  anchorX="center"
                  anchorY="middle"
                  textAlign="center"
                  scale={icon ? 10 : 4}
                >
                  {label}
                </Text>
              </RenderTextureScene>
            </RenderTexture>
          </meshBasicMaterial>
        </mesh>
      </group>
    </group>
  )
}
